import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./DetailSection.scss";
import impexp from "../../assets/images/importexportimg.png";
// import { getCasesByName, getTasks, searchParties } from "../../api/auth.js";
import {
  getCasesByName,
  getDistrictCourtCasesAddedManually,
  getDistrictCourtCasesByCompany,
  getHighCourtCasesAddedManually,
  getHighCourtCasesByCompany,
  getIsCheckedDistrictCourtCasesAddedManually,
  getIsCheckedDistrictCourtCasesByCompany,
  getIsCheckedHighCourtCasesAddedManually,
  getIsCheckedHighCourtCasesByCompany,
  getIsCheckedOtherCourtCasesAddedManually,
  getOtherCourtCasesAddedManually,
  uploadCasesSpreadsheet,
} from "../../services/api/CasesApi.js";
import {
  getTasks,
  getTasksAssignedByUser,
  getTasksAssignedToUser,
} from "../../services/api/TaskApi.js";
import {
  searchParties,
  searchExpenses,
  searchLabel,
  searchMyClient,
  InvoiceForCompany,
  InvoiceForClient,
  searchNote,
  searchAddedUsers,
  searchHighCaseFetched,
  searchHighCaseManual,
  searchDistrictCaseFetched,
  searchDistrictCaseManual,
} from "../../services/api/SearchApi.js";
import { useSearchResults } from "../../context/SearchResultsContext.js";
import { exportCasesToPDF } from "../exportPdf.js";
import DetailCard from "../DetailCard/DetailCard.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../context/LoadingContext.js";
import { getMyClients } from "../../services/api/MyClientsApi.js";
import { getLabelsByUser } from "../../services/api/LabelsApi.js";
import { useAuth } from "../../context/AuthContext.js";
import { getallBranchNames } from "../../services/api/BranchApi.js";
import {
  getalllawyersCreatedByMe,
  getUserLimit,
} from "../../services/api/AddUsersApi.js";
import { getNoteByUser } from "../../services/api/NoteApi.js";
import { getExpenseByUser } from "../../services/api/ExpenseApi.js";
import {
  getInvoicesCompany,
  getInvoicesCustomer,
} from "../../services/api/InvoicesApi.js";
import { getHierarchy } from "../../services/api/HierarchyApi.js";
import { exportTasksToExcel } from "../exportTaskstoExcel.js";
import { useCaseSelection } from "../../context/CaseSelectionContext.js";
import {
  getDistrictCourtCustomerCases,
  getHighCourtCustomerCases,
  getOtherCourtCustomerCases,
} from "../../services/api/CustomerDashApi.js";
import { useToast } from "../../context/ToastContext";
import CommonModal from "../CommonModal/CommonModal.js";
import { ExportInvoicetoExcel } from "../ExportInvoicetoExcel.js";
import { BranchForm } from "../../forms/BranchForm/BranchForm.js";
import { useGlobalSettings } from "../../context/GlobalSettingsContext.js";
import { useTaskSelection } from "../../context/TaskSelectionContext.js";
import { useInvoiceSelection } from "../../context/InvoiceSelectionContext.js";
import { useLabelSelection } from "../../context/LabelSelectionContext.js";
import { useNoteSelection } from "../../context/NoteSelectionContext.js";
import { useExpenseSelection } from "../../context/ExpenseSelectionContext.js";
import { useUserSelection } from "../../context/UserSelectionContext.js";
import { useClientSelection } from "../../context/ClientSelectionContext.js";
import { useCaseLimit } from "../../context/CaseLimitContext.js";
import caseSampleSheet from "../../components/upload_cases_sample_sheet.xlsx";
import userSampleSheet from "../../components/hdfc_gandhinagar_users_test.xlsx";
import { uploadUsersSpreadsheetUsers } from "../../services/api/AddUsersApi.js";

export const DetailSection = ({ username, activeTab }) => {
  const location = useLocation();
  const [selectedYear, setSelectedYear] = useState("all");
  const isCases = location.pathname === "/home/cases";
  const isTasks = location.pathname === "/home/tasks";
  const isInvoices = location.pathname === "/home/invoices";
  const { company, role } = useAuth();
  const [isInvoiceExportModalOpen, setIsInvoiceExportModalOpen] =
    useState(false);
  const [isPdfExportModalOpen, setIsPdfExportModalOpen] = useState(false);
  const [pdfOrientation, setPdfOrientation] = useState("portrait");
  const companyID = company?._id;
  const [detailSecData, setDetailSecData] = useState([]);
  const [TaskSecData, setTaskSecData] = useState([]);
  const [MyClientsData, setMyClientsData] = useState([]);
  const [LabelData, setLabelData] = useState([]);
  const [ExpenseData, setExpenseData] = useState([]);
  const [NotesData, setNotesData] = useState([]);
  const [InvoiceData, setInvoiceData] = useState([]);
  const [BranchData, setBranchData] = useState([]);
  // Add this state near the top with other state declarations
  const [companyStats, setCompanyStats] = useState(null);

  const [userLimitData, setUserLimitData] = useState(null);
  const [isUserLimitLoading, setIsUserLimitLoading] = useState(false);

  const [hasPerformedSearch, setHasPerformedSearch] = useState(false);

  const {
    taskTab,
    selectedCard,
    handleCardClick,
    pagination: taskPagination,
    refreshKey,
  } = useTaskSelection(); // Updated
  const [isCaseLimitModalOpen, setIsCaseLimitModalOpen] = useState(false);

  const { setSearchTerm } = useTaskSelection();
  
  // Use CaseLimitContext instead of local state
  const { caseLimitData, isLoading: isCaseLimitLoading, refreshCaseLimitData } = useCaseLimit();

  const {
    selectedCard: selectedInvoiceCard,
    handleCardClick: handleInvoiceCardClick,
    searchTerm: invoiceSearchTerm,
    setSearchTerm: setInvoiceSearchTerm,
    filters: invoiceFilters,
    setFilters: setInvoiceFilters,
    setFilteredInvoices,
    pagination: invoicePagination,
    updatePaginationInfo: updateInvoicePaginationInfo,
    refreshKey: invoiceRefreshKey,
    buildQueryParams: buildInvoiceQueryParams,
    clearAllFilters: clearInvoiceFilters,
  } = useInvoiceSelection();

  const {
    searchTerm: labelSearchTerm,
    setSearchTerm: setLabelSearchTerm,
    filters: labelFilters,
    setFilters: setLabelFilters,
    filteredLabels,
    setFilteredLabels,
    refreshKey: labelRefreshKey,
    pagination: labelPagination,
    updatePaginationInfo: updateLabelPaginationInfo,
  } = useLabelSelection();

  const {
    searchTerm: expenseSearchTerm,
    setSearchTerm: setExpenseSearchTerm,
    filters: expenseFilters,
    setFilters: setExpenseFilters,
    filteredExpenses,
    setFilteredExpenses,
    hasActiveFilters: hasExpenseFilters,
    pagination: expensePagination,
    updatePaginationInfo: updateExpensePaginationInfo,
    refreshKey: expenseRefreshKey,
  } = useExpenseSelection();

  const {
    searchTerm: userSearchTerm,
    setSearchTerm: setUserSearchTerm,
    filters: userFilters,
    setFilters: setUserFilters,
    filteredUsers,
    setFilteredUsers,
    selectedCard: selectedUserCard,
    handleCardClick: handleUserCardClick,
    hasActiveFilters: hasUserFilters,
    clearAllFilters: clearUserFilters,
    refreshKey: userRefreshKey,
    pagination: userPagination,
    updatePaginationInfo: updateUserPaginationInfo,
  } = useUserSelection();

  // Add this state in your DetailSection component
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedDateRange, setSelectedDateRange] = useState("current-month");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [AddUserData, setAddUserData] = useState([]);
  const [searchdetailSecData, setsearchDetailSecData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const {
    searchResults,
    setSearchResults,
    searchType,
    setSearchType,
    searchMetadata,
    setSearchMetadata,
  } = useSearchResults();
  const {
    selectedCaseType,
    setSelectedCaseType,
    selectedCourtType,
    setSelectedCourtType,
    filteredCases,
    filters,
    setFilters,
    selectedAssignedUser,
    setSelectedAssignedUser,
    selectedCaseCard,
    handleCaseCardClick,
    setFilteredCases,
    isLoading, // Add this
    setIsLoading,
    refreshKey: caseRefreshKey,
    pagination,
    updatePaginationInfo: updateCasePaginationInfo,
    searchTerm: caseSearchTerm,
    setSearchTerm: setCaseSearchTerm,
    triggerCaseRefresh,
  } = useCaseSelection();

  const {
    searchTerm: noteSearchTerm,
    setSearchTerm: setNoteSearchTerm,
    filters: noteFilters,
    setFilters: setNoteFilters,
    filteredNotes,
    setFilteredNotes,
    refreshKey: noteRefreshKey,
    pagination: notePagination,
    updatePaginationInfo: updateNotePaginationInfo,
  } = useNoteSelection();

  const {
    searchTerm: clientSearchTerm,
    setSearchTerm: setClientSearchTerm,
    filters: clientFilters,
    setFilters: setClientFilters,
    filteredClients,
    setFilteredClients,
    hasActiveFilters: hasClientFilters,
    clearAllFilters: clearClientFilters,
    refreshKey: clientRefreshKey,
    pagination: clientPagination,
    updatePaginationInfo: updateClientPaginationInfo,
  } = useClientSelection();

  const [isNewBranchModalOpen, setIsNewBranchModalOpen] = useState(false);
  const [isImportCasesModalOpen, setIsImportCasesModalOpen] = useState(false);
  const [isImportUsersModalOpen, setIsImportUsersModalOpen] = useState(false);
  const { showLoading, hideLoading } = useLoading();
  const navigate = useNavigate();
  const global = useGlobalSettings();
  const avail_currency =
    global?.globalSettings?.result?.[0].expenseSettings?.currency;

  const currencySign = avail_currency === "INR" ? "₹" : "$";

  const limit = 10;
  const page = 1;

  const { showToast } = useToast();
  const [isUserLimitModalOpen, setIsUserLimitModalOpen] = useState(false);

  useEffect(() => {
    if (activeTab === "Cases") {
      setCaseSearchTerm(searchInput || "");
      console.log("Syncing case search input to context:", searchInput);
    }
    if (activeTab === "Tasks") {
      setSearchTerm(searchInput || "");
      console.log("Syncing search input to context:", searchInput);
    }
    if (activeTab === "Invoices") {
      setInvoiceSearchTerm(searchInput || "");
      console.log("Syncing invoice search input to context:", searchInput);
    }
    if (activeTab === "Labels") {
      setLabelSearchTerm(searchInput || "");
      console.log("Syncing label search input to context:", searchInput);
    }
    if (activeTab === "Notes") {
      setNoteSearchTerm(searchInput || "");
      console.log("Syncing note search input to context:", searchInput);
    }
    if (activeTab === "Expenses") {
      setExpenseSearchTerm(searchInput || "");
      console.log("Syncing expense search input to context:", searchInput);
    }
    if (activeTab === "Manage Users") {
      setUserSearchTerm(searchInput || "");
      console.log("Syncing user search input to context:", searchInput);
    }
    if (activeTab === "Add My Clients") {
      setClientSearchTerm(searchInput || "");
      console.log("Syncing client search input to context:", searchInput);
    }
  }, [
    searchInput,
    activeTab,
    setSearchTerm,
    setInvoiceSearchTerm,
    setLabelSearchTerm,
    setNoteSearchTerm,
    setExpenseSearchTerm,
    setUserSearchTerm,
    setClientSearchTerm,
    setCaseSearchTerm,
  ]);

  const buildQueryParams = useCallback(
    (searchTerm) => {
      const params = new URLSearchParams();

      if (searchTerm && searchTerm.trim()) {
        params.set("search", searchTerm.trim());
      }

      // Use shared filters from context
      if (filters.status && filters.status !== "") {
        params.set("status", filters.status);
      }

      if (filters.type && filters.type !== "all") {
        params.set("type", filters.type);
      }

      // FIXED: Add assignedIds parameter
      if (selectedAssignedUser && selectedAssignedUser !== "") {
        params.set("assignedIds", selectedAssignedUser);
      }

      // Date filters
      if (filters.filingDateFrom)
        params.set("filingDateFrom", filters.filingDateFrom);
      if (filters.filingDateTo)
        params.set("filingDateTo", filters.filingDateTo);
      if (filters.registrationDateFrom)
        params.set("registrationDateFrom", filters.registrationDateFrom);
      if (filters.registrationDateTo)
        params.set("registrationDateTo", filters.registrationDateTo);
      if (filters.firstHearingDateFrom)
        params.set("firstHearingDateFrom", filters.firstHearingDateFrom);
      if (filters.firstHearingDateTo)
        params.set("firstHearingDateTo", filters.firstHearingDateTo);
      if (filters.decisionDateFrom)
        params.set("decisionDateFrom", filters.decisionDateFrom);
      if (filters.decisionDateTo)
        params.set("decisionDateTo", filters.decisionDateTo);

      return params.toString();
    },
    [filters, selectedAssignedUser] // Add selectedAssignedUser to dependencies
  );

  // Case limit data is now managed by CaseLimitContext
  // No need for local useEffect

  useEffect(() => {
    const fetchCases = async () => {
      try {
        setIsLoading(true); // Start loading

        const params = new URLSearchParams();
        // Use pagination state from context
        params.set("page", pagination.page.toString());
        params.set("limit", pagination.limit.toString());

        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
        }

        // if (selectedCaseCard) {
        //   params.set("onClick", selectedCaseCard);
        // }
        // Only add the onClick parameter if a specific filter card (not 'total') is selected.
        if (selectedCaseCard && selectedCaseCard !== "total") {
          params.set("onClick", selectedCaseCard);
        }

        if (filters && Object.keys(filters).length > 0) {
          Object.entries(filters).forEach(([key, value]) => {
            if (value && value.trim() && value !== "all") {
              params.set(key, value.trim());
            }
          });
        }

        if (selectedAssignedUser && selectedAssignedUser !== "") {
          params.set("assignedIds", selectedAssignedUser);
        }

        const queryString = params.toString();
        let response;

        if (role === "customer") {
          if (selectedCourtType === "HighCourt") {
            response = await getHighCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          } else if (selectedCourtType === "DistrictCourt") {
            response = await getDistrictCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          } else if (selectedCourtType === "OtherCourt") {
            response = await getOtherCourtCustomerCases(
              queryString ? `?${queryString}` : ""
            );
          }
        } else {
          if (selectedCourtType === "OtherCourt") {
            response = await getIsCheckedOtherCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedHighCourtCasesByCompany(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedHighCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedDistrictCourtCasesByCompany(
              queryString ? `?${queryString}` : ""
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedDistrictCourtCasesAddedManually(
              queryString ? `?${queryString}` : ""
            );
          }
        }

        const caseData = response?.data || {};
        setDetailSecData(caseData);
        setFilteredCases(caseData.cases || []);

        updateCasePaginationInfo(
          caseData.totalCases || 0,
          (caseData.cases || []).length === pagination.limit
        );

        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          selectedCaseCard ||
          selectedAssignedUser !== "" ||
          (filters &&
            Object.values(filters).some(
              (val) => val && val.trim() && val !== "all"
            ));

        if (hasActiveSearch || hasActiveFilters) {
          // The search results will also be paginated now
          setSearchResults(caseData.cases || []);
          setSearchType("cases");
          setSearchMetadata({
            selectedCaseCard,
            selectedCourtType,
            selectedCaseType,
            filters,
            selectedAssignedUser,
            searchTerm: searchInput,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching cases:", err);
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredCases([]);
        updateCasePaginationInfo(0, false); // Reset pagination on error
        setIsLoading(false); // Stop loading on error
      }
    };

    if (activeTab === "Cases") {
      fetchCases();
    }
  }, [
    selectedCaseCard,
    selectedCourtType,
    selectedCaseType,
    searchInput,
    filters,
    selectedAssignedUser,
    activeTab,
    role,
    setFilteredCases,
    setIsLoading,
    caseRefreshKey,
    pagination.page, // Add dependency on page number
    pagination.limit, // Add dependency on page size
    updateCasePaginationInfo, // Add dependency on update function
  ]);

  const handleInvoiceExport = async () => {
    try {
      const res =
        role === "customer"
          ? await getInvoicesCustomer()
          : await getInvoicesCompany();

      let invoices = res.data.invoice || [];

      if (selectedStatus !== "all") {
        invoices = invoices.filter((inv) => inv.status === selectedStatus);
      }

      if (selectedDateRange !== "all") {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        invoices = invoices.filter((inv) => {
          const invoiceDate = new Date(inv.createdAt);
          const invoiceYear = invoiceDate.getFullYear();
          const invoiceMonth = invoiceDate.getMonth();

          switch (selectedDateRange) {
            case "current-month":
              return (
                invoiceYear === currentYear && invoiceMonth === currentMonth
              );

            case "last-month":
              const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
              const lastMonthYear =
                currentMonth === 0 ? currentYear - 1 : currentYear;
              return (
                invoiceYear === lastMonthYear && invoiceMonth === lastMonth
              );

            case "june-2025":
              return invoiceYear === 2025 && invoiceMonth === 5;

            case "may-2025":
              return invoiceYear === 2025 && invoiceMonth === 4;

            case "april-2025":
              return invoiceYear === 2025 && invoiceMonth === 3;

            case "march-2025":
              return invoiceYear === 2025 && invoiceMonth === 2;

            case "select-range":
              if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);
                return invoiceDate >= start && invoiceDate <= end;
              }
              return true;

            case "previous-fy":
              const currentFYStartYear =
                currentMonth >= 3 ? currentYear : currentYear - 1;
              const previousFYStartYear = currentFYStartYear - 1;
              const previousFYEndYear = currentFYStartYear;

              return (
                (invoiceYear === previousFYStartYear && invoiceMonth >= 3) ||
                (invoiceYear === previousFYEndYear && invoiceMonth < 3)
              );

            case "select-range":
              return true;

            default:
              return true;
          }
        });
      }

      if (invoices.length === 0) {
        showToast("No invoices found for the selected filters", "warning");
        return;
      }

      await ExportInvoicetoExcel(
        invoices,
        `${selectedStatus}_${selectedDateRange}`
      );
      setIsInvoiceExportModalOpen(false);

      const statusText = selectedStatus === "all" ? "All" : selectedStatus;
      const dateRangeText =
        selectedDateRange === "all"
          ? "All dates"
          : selectedDateRange
              .replace("-", " ")
              .replace(/\b\w/g, (l) => l.toUpperCase());

      showToast(
        `${invoices.length} invoices exported (${statusText} - ${dateRangeText})`,
        "success"
      );
    } catch (err) {
      console.error("Export failed:", err);
      showToast("Export failed. Please try again.", "error");
    }
  };

  const handleExportPDF = (orientation) => {
    let casesToExport = [];

    if (searchResults.length > 0) {
      casesToExport = searchResults;
    } else if (filteredCases.length > 0) {
      casesToExport = filteredCases;
    } else {
      casesToExport = detailSecData.cases || [];
    }

    exportCasesToPDF(casesToExport, orientation);
    setIsPdfExportModalOpen(false);

    let exportMessage = `Cases exported to PDF in ${orientation} format`;
    if (searchResults.length > 0) {
      exportMessage = `${searchResults.length} search result cases exported to PDF in ${orientation} format`;
    } else if (filteredCases.length > 0) {
      exportMessage = `${filteredCases.length} filtered cases exported to PDF in ${orientation} format`;
    }

    showToast(exportMessage, "success");
  };

  const getMonthName = (monthIndex) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthIndex];
  };

  useEffect(() => {
    const fetchUserLimitData = async () => {
      try {
        setIsUserLimitLoading(true);
        const response = await getUserLimit();
        console.log(response.data, "User Limit API Response on mount");
        setUserLimitData(response.data);
      } catch (error) {
        console.error("Error fetching user limit on mount:", error);
        setUserLimitData(null);
      } finally {
        setIsUserLimitLoading(false);
      }
    };

    fetchUserLimitData();
  }, []);

  useEffect(() => {
    const fetchInvoiceData = async () => {
      if (activeTab !== "Invoices") return;

      try {
        setIsLoading(true);
        const response =
          role === "customer"
            ? await getInvoicesCustomer()
            : await getInvoicesCompany();

        const invoiceData = response?.data || {};
        console.log("Invoice data fetched for stats:", invoiceData);
        setInvoiceData(invoiceData);
      } catch (err) {
        console.error("Error fetching invoice data:", err);
        setInvoiceData({});
      } finally {
        setIsLoading(false);
      }
    };

    fetchInvoiceData();
  }, [activeTab, role, invoiceRefreshKey]);

  useEffect(() => {
    window.setDetailSectionInvoiceData = (data) => {
      console.log("Setting invoice data from Invoices component:", data);
      setInvoiceData(data);
    };

    return () => {
      delete window.setDetailSectionInvoiceData;
    };
  }, []);

  useEffect(() => {
    if (!selectedCourtType) {
      console.log("No court type selected, skipping fetch");
      return;
    }

    if (
      role !== "customer" &&
      selectedCourtType !== "OtherCourt" &&
      !selectedCaseType
    ) {
      console.log("No case type selected for non-customer, skipping fetch");
      return;
    }

    const getMonthName = (monthIndex) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthIndex];
    };

    const getAvailableMonths = (invoices) => {
      const monthSet = new Set();
      invoices.forEach((invoice) => {
        const date = new Date(invoice.createdAt);
        const monthYear = `${date.getFullYear()}-${date.getMonth()}`;
        monthSet.add(monthYear);
      });

      return Array.from(monthSet)
        .sort()
        .map((monthYear) => {
          const [year, month] = monthYear.split("-");
          return {
            value: monthYear,
            label: `${getMonthName(parseInt(month))} ${year}`,
          };
        });
    };

    const fetchDetailedCases = async () => {
      try {
        let response;
        const queryParams = "";

        console.log("Fetching cases with:", {
          selectedCourtType,
          selectedCaseType,
          role,
          queryParams,
          filters,
        });
        if (role !== "customer") {
          if (selectedCourtType === "OtherCourt") {
            response = await getIsCheckedOtherCourtCasesAddedManually(
              `?${queryParams}`
            );
            console.log(response, "othercourt cases knfsjkg");
          } else if (selectedCourtType === "HighCourt") {
            if (selectedCaseType === "fetched") {
              response = await getIsCheckedHighCourtCasesByCompany(
                `?${queryParams}`
              );
              console.log(response, "highcourt fetched knfsjkg");
            } else if (selectedCaseType === "added") {
              response = await getIsCheckedHighCourtCasesAddedManually(
                `?${queryParams}`
              );
              console.log(response, "highcourt added knfsjkg");
            } else {
              showToast("Please select case type for High Court", "error");
              return;
            }
          } else if (selectedCourtType === "DistrictCourt") {
            if (selectedCaseType === "fetched") {
              response = await getIsCheckedDistrictCourtCasesByCompany(
                `?${queryParams}`
              );
              console.log(response, "districtcourt fetched knfsjkg");
            } else if (selectedCaseType === "added") {
              response = await getIsCheckedDistrictCourtCasesAddedManually(
                `?${queryParams}`
              );
              console.log(response, "districtcourt added knfsjkg");
            } else {
              showToast("Please select case type for District Court", "error");
              return;
            }
          } else {
            showToast("Invalid Court Type", "error");
            return;
          }
        } else {
          if (selectedCourtType === "HighCourt") {
            response = await getHighCourtCustomerCases();
            console.log(response, "customer highcourt");
          } else if (selectedCourtType === "DistrictCourt") {
            response = await getDistrictCourtCustomerCases();
            console.log(response, "customer districtcourt");
          } else if (selectedCourtType === "OtherCourt") {
            response = await getOtherCourtCasesAddedManually();
            console.log(response, "customer othercourt");
          } else {
            showToast("Invalid Court Type", "warning");
            return;
          }
        }

        const detaildata = response?.data || [];
        console.log("Setting detail data:", detaildata);
        setDetailSecData(detaildata);
      } catch (error) {
        console.error("Error fetching detailed cases:", error);
        setDetailSecData([]);
      }
    };
    // fetchDetailedCases(); // This fetch is now redundant due to the main fetchCases useEffect
  }, [
    username,
    selectedCaseType,
    selectedCourtType,
    role,
    filters,
    selectedAssignedUser,
  ]);

  useEffect(() => {
    if (activeTab === "Cases" && caseLimitData) {
      // Use the preloaded caseLimitData instead of fetching again
      setCompanyStats(caseLimitData);
    }
  }, [activeTab, caseLimitData]);

  // useEffect(() => {
  //   if (activeTab === "Cases") {
  //     const fetchCompanyStats = async () => {
  //       try {
  //         const response = await getCompanyLimitedStats();
  //         setCompanyStats(response?.data);
  //       } catch (error) {
  //         console.error("Error fetching company stats:", error);
  //       }
  //     };

  //     fetchCompanyStats();
  //   }
  // }, [activeTab]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        let response;

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();
        params.set("page", taskPagination?.page?.toString() || "0");
        params.set("limit", taskPagination?.limit?.toString() || "20");

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log("Adding search term to query:", searchInput.trim());
        }

        // Add card-based filtering
        if (selectedCard) {
          console.log("Adding card filter:", selectedCard);
          switch (selectedCard) {
            case "completed":
              params.set("isCompleted", "true");
              params.set("onClick", "completed");
              break;
            case "pending":
              params.set("isCompleted", "false");
              params.set("onClick", "pending");
              break;
            case "today":
              params.set("onClick", "today");
              break;
            case "total":
              params.set("onClick", "total");
              break;
          }
        }

        // Add filter parameters from TaskSelectionContext
        if (filters && Object.keys(filters).length > 0) {
          console.log("Adding filters to query:", filters);
          Object.entries(filters).forEach(([key, value]) => {
            if (value && value.trim()) {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final query string:", queryString);

        // Make API call
        if (taskTab === "assignedToMe") {
          response = await getTasksAssignedToUser(
            queryString ? `?${queryString}` : ""
          );
        } else if (taskTab === "assignedByMe") {
          response = await getTasksAssignedByUser(
            queryString ? `?${queryString}` : ""
          );
        }

        const taskdata = response?.data || {};
        console.log(
          "DetailSection API response tasks count:",
          taskdata.tasks?.length || 0
        );

        setTaskSecData(taskdata);

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          selectedCard ||
          (filters && Object.values(filters).some((val) => val && val.trim()));

        console.log("Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting search results with",
            (taskdata.tasks || []).length,
            "tasks"
          );
          setSearchResults(taskdata.tasks || []);
          setSearchType("tasks");
          setSearchMetadata({
            taskTab,
            selectedCard,
            filters,
            searchTerm: searchInput,
            totalTasks: taskdata.tasks?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log("No active search/filters - clearing search state");
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching tasks:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
      }
    };

    // Only run if we're on Tasks tab
    if (activeTab === "Tasks") {
      console.log("Running Tasks fetch with current state:", {
        taskTab,
        selectedCard,
        searchInput,
        filters,
      });
      fetchTasks();
    }
  }, [
    taskTab,
    selectedCard,
    searchInput,
    filters,
    activeTab,
    taskPagination?.page,
    taskPagination?.limit,
    setSearchResults,
    setSearchType,
    setSearchMetadata,
    refreshKey,
  ]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();
        // params.set("page", "0");
        // params.set("limit", "100");
        params.set("page", clientPagination.page.toString());
        params.set("limit", clientPagination.limit.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log(
            "Adding client search term to query:",
            searchInput.trim()
          );
        }

        // Add filter parameters from ClientSelectionContext
        if (clientFilters && Object.keys(clientFilters).length > 0) {
          console.log("Adding client filters to query:", clientFilters);
          Object.entries(clientFilters).forEach(([key, value]) => {
            if (value && value.trim()) {
              // Map context filter names to API parameter names
              const apiKey = key === "clientName" ? "name" : key;
              params.set(apiKey, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final client query string:", queryString);

        // Make API call
        response = await getMyClients(queryString ? `?${queryString}` : "");

        const clientData = response?.data || {};
        console.log(
          "DetailSection API response client count:",
          clientData.client?.length || 0
        );

        setMyClientsData(clientData);

        // Update context with filtered results
        setFilteredClients(clientData.client || []);

        // if (clientData.total !== undefined) {
        //   updateClientPaginationInfo(
        //     clientData.total,
        //     clientData.total > (clientPagination.page + 1) * clientPagination.limit
        //   );
        // }

        if (clientData.clientCount !== undefined) {
          updateClientPaginationInfo(
            clientData.clientCount,
            clientData.clientCount >
              (clientPagination.page + 1) * clientPagination.limit
          );
        }

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          clientFilters &&
          Object.values(clientFilters).some((val) => val && val.trim());

        console.log("Client Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting client search results with",
            (clientData.client || []).length,
            "clients"
          );
          setSearchResults(clientData.client || []);
          setSearchType("clients");
          setSearchMetadata({
            filters: clientFilters,
            searchTerm: searchInput,
            totalClients: clientData.client?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log(
            "No active client search/filters - clearing search state"
          );
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching clients:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateClientPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Add My Clients tab
    if (activeTab === "Add My Clients") {
      console.log("Running Client fetch with current state:", {
        searchInput,
        clientFilters,
      });
      fetchClients();
    }
  }, [
    searchInput,
    clientFilters,
    activeTab,
    setFilteredClients,
    clientRefreshKey,
    clientPagination.page,
    clientPagination.limit,
    updateClientPaginationInfo,
  ]);

  useEffect(() => {
    const fetchLabels = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();
        // params.set("page", "0");
        // params.set("limit", "20");

        params.set("page", labelPagination?.page?.toString()); // Use context pagination
        params.set("limit", labelPagination?.limit?.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log("Adding label search term to query:", searchInput.trim());
        }

        // Add filter parameters from LabelSelectionContext
        if (labelFilters && Object.keys(labelFilters).length > 0) {
          console.log("Adding label filters to query:", labelFilters);
          Object.entries(labelFilters).forEach(([key, value]) => {
            if (value && value.trim()) {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final label query string:", queryString);

        // Make API call
        response = await getLabelsByUser(queryString ? `?${queryString}` : "");

        const labelData = response?.data || {};
        console.log(
          "DetailSection API response label count:",
          labelData.labels?.length || 0
        );

        setLabelData(labelData);

        // Process the labels (flatten the structure like in original Labels component)
        const processedLabels = labelData.labels
          ? labelData.labels.flatMap((item) =>
              item.labels.map((label) => ({
                _id: label._id,
                name: label.name,
                color: label.color,
                description: label.description,
                priorityLevel: label.priorityLevel,
                createdAt: label.createdAt,
                branchId: label.branchId,
                courtRef: label.courtRef,
                user: label.user,
                labeldata: label,
              }))
            )
          : [];

        // Update context with filtered results
        setFilteredLabels(processedLabels);
        if (labelData.total !== undefined) {
          updateLabelPaginationInfo(
            labelData.total,
            labelData.total >
              (labelPagination?.page + 1) * labelPagination?.limit
          );
        }

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          labelFilters &&
          Object.values(labelFilters).some((val) => val && val.trim());

        console.log("Label Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting label search results with",
            processedLabels.length,
            "labels"
          );
          setSearchResults(processedLabels);
          setSearchType("labels");
          setSearchMetadata({
            filters: labelFilters,
            searchTerm: searchInput,
            totalLabels: processedLabels.length,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log("No active label search/filters - clearing search state");
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching labels:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateLabelPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Labels tab
    if (activeTab === "Labels") {
      console.log("Running Label fetch with current state:", {
        searchInput,
        labelFilters,
      });
      fetchLabels();
    }
  }, [
    searchInput,
    labelFilters,
    activeTab,
    setFilteredLabels,
    labelRefreshKey,
    labelPagination?.page, // Add pagination dependencies
    labelPagination?.limit,
    updateLabelPaginationInfo,
  ]);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      try {
        const response = await getallBranchNames(companyID);
        const branchdata = response?.data;
        console.log(branchdata, "bd");
        setBranchData(branchdata);
        console.log(BranchData, "BranchData");
      } catch (err) {
        console.error("Error fetching my branches:", err);
      }
    };
    fetchBranchDetails();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        let response;

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();
        // params.set("page", "0");
        // params.set("limit", "100");
        params.set("page", userPagination.page.toString());
        params.set("limit", userPagination.limit.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log("Adding user search term to query:", searchInput.trim());
        }

        if (selectedUserCard) {
          console.log("Adding user card filter:", selectedUserCard);
          // Map card types to API parameters correctly
          if (selectedUserCard === "active") {
            params.set("status", "active");
          } else if (selectedUserCard === "inactive") {
            params.set("status", "inActive");
            params.set("onClick", "inActive");
          } else if (selectedUserCard === "total") {
            // Don't set isActive for total - show all users
            params.set("onClick", selectedUserCard);
          }
          // Always include onClick for backend compatibility
        }

        if (userFilters && Object.keys(userFilters).length > 0) {
          console.log("Adding user filters to query:", userFilters);
          Object.entries(userFilters).forEach(([key, value]) => {
            if (value && value.trim()) {
              // Map filter keys to correct API parameters
              if (key === "status") {
                if (value === "active") {
                  params.set("status", "active");
                } else if (value === "inactive") {
                  params.set("status", "inActive");
                }
              } else {
                params.set(key, value.trim());
              }
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final user query string:", queryString);

        // Make API call
        response = await getHierarchy(queryString ? `?${queryString}` : "");

        const userData = response?.data || {};
        console.log(
          "DetailSection API response user count:",
          userData.users?.length || 0
        );

        setAddUserData(userData);

        // Update context with filtered results
        setFilteredUsers(userData.users || []);
        if (userData.totalUsers !== undefined) {
          updateUserPaginationInfo(
            userData.totalUsers,
            userData.totalUsers >
              (userPagination.page + 1) * userPagination.limit
          );
        }

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          selectedUserCard ||
          (userFilters &&
            Object.values(userFilters).some((val) => val && val.trim()));

        console.log("User Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting user search results with",
            (userData.users || []).length,
            "users"
          );
          setSearchResults(userData.users || []);
          setSearchType("addusers");
          setSearchMetadata({
            selectedCard: selectedUserCard,
            filters: userFilters,
            searchTerm: searchInput,
            totalUsers: userData.users?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log("No active user search/filters - clearing search state");
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredUsers([]);
        updateUserPaginationInfo(0, false); // Reset pagination on error
      }
    };

    // Only run if we're on Manage Users tab
    if (activeTab === "Manage Users") {
      console.log("Running User fetch with current state:", {
        selectedUserCard,
        searchInput,
        userFilters,
      });
      fetchUsers();
    }
  }, [
    selectedUserCard,
    searchInput,
    userFilters,
    activeTab,
    setFilteredUsers,
    userRefreshKey,
    userPagination.page,
    userPagination.limit,
    updateUserPaginationInfo,
  ]);

  // useEffect(() => {
  //   const fetchaddusersDetails = async () => {
  //     try {
  //       const response = await getHierarchy();
  //       const alladdusersdata = response?.data;
  //       setAddUserData(alladdusersdata);
  //       console.log(AddUserData, "AddUserData");
  //     } catch (err) {
  //       console.error("Error fetching my added users:", err);
  //     }
  //   };
  //   fetchaddusersDetails();
  // }, []);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();
        // params.set("page", "0");
        // params.set("limit", "20");
        params.set("page", notePagination.page.toString());
        params.set("limit", notePagination.limit.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log("Adding note search term to query:", searchInput.trim());
        }

        // Add filter parameters from NoteSelectionContext
        if (noteFilters && Object.keys(noteFilters).length > 0) {
          console.log("Adding note filters to query:", noteFilters);
          Object.entries(noteFilters).forEach(([key, value]) => {
            if (value && value.trim()) {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final note query string:", queryString);

        // Make API call
        response = await getNoteByUser(queryString ? `?${queryString}` : "");

        const noteData = response?.data || {};
        console.log(
          "DetailSection API response note count:",
          noteData.notes?.length || 0
        );

        setNotesData(noteData);

        // Update context with filtered results
        setFilteredNotes(noteData.notes || []);

        if (response.data.total !== undefined) {
          updateNotePaginationInfo(
            response.data.total,
            response.data.total >
              (notePagination.page + 1) * notePagination.limit
          );
        }

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          noteFilters &&
          Object.values(noteFilters).some((val) => val && val.trim());

        console.log("Note Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting note search results with",
            (noteData.notes || []).length,
            "notes"
          );
          setSearchResults(noteData.notes || []);
          setSearchType("notes");
          setSearchMetadata({
            filters: noteFilters,
            searchTerm: searchInput,
            totalNotes: noteData.notes?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log("No active note search/filters - clearing search state");
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching notes:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        updateNotePaginationInfo(0, false);
      }
    };

    // Only run if we're on Notes tab
    if (activeTab === "Notes") {
      console.log("Running Note fetch with current state:", {
        searchInput,
        noteFilters,
      });
      fetchNotes();
    }
  }, [
    searchInput,
    noteFilters,
    activeTab,
    setFilteredNotes,
    noteRefreshKey,
    notePagination?.page,
    notePagination?.limit,
    updateNotePaginationInfo,
  ]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        let response;

        // Build query parameters that include search + filters
        const params = new URLSearchParams();
        params.set("page", expensePagination.page.toString());
        params.set("limit", expensePagination.limit.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log(
            "Adding expense search term to query:",
            searchInput.trim()
          );
        }

        // FIXED: Add filter parameters with proper empty string checking
        if (expenseFilters && Object.keys(expenseFilters).length > 0) {
          console.log("Adding expense filters to query:", expenseFilters);
          Object.entries(expenseFilters).forEach(([key, value]) => {
            // IMPORTANT: Check for both truthy value AND non-empty string after trimming
            if (value && typeof value === "string" && value.trim() !== "") {
              // Map frontend filter names to API parameter names
              let apiKey = key;
              if (key === "type") apiKey = "expenseType";

              params.set(apiKey, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final expense query string:", queryString);

        // Make API call
        response = await getExpenseByUser(queryString ? `?${queryString}` : "");

        const expenseData = response?.data || {};
        console.log(
          "DetailSection API response expense count:",
          expenseData.expenses?.length || 0
        );

        setExpenseData(expenseData);
        setFilteredExpenses(expenseData.expenses || []);

        if (expenseData.expenseCount !== undefined) {
          updateExpensePaginationInfo(
            expenseData.expenseCount,
            expenseData.expenseCount >
              (expenseData.page + 1) * expenseData.limit
          );
        }

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          expenseFilters &&
          Object.values(expenseFilters).some(
            (val) => val && typeof val === "string" && val.trim() !== ""
          );

        console.log("Expense Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting expense search results with",
            (expenseData.expenses || []).length,
            "expenses"
          );
          setSearchResults(expenseData.expenses || []);
          setSearchType("expenses");
          setSearchMetadata({
            filters: expenseFilters,
            searchTerm: searchInput,
            totalExpenses: expenseData.expenses?.length || 0,
            isUnified: true,
          });
          setHasPerformedSearch(true);
        } else {
          console.log(
            "No active expense search/filters - clearing search state"
          );
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching expenses:", err);
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
      }
    };

    if (activeTab === "Expenses") {
      console.log("Running Expense fetch with current state:", {
        searchInput,
        expenseFilters,
      });
      fetchExpenses();
    }
  }, [
    searchInput,
    expenseFilters,
    activeTab,
    setFilteredExpenses,
    updateExpensePaginationInfo,
    expenseRefreshKey,
  ]);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        let response;
        setIsLoading(true);

        // Build query parameters that include search + filters + cards
        const params = new URLSearchParams();
        params.set("page", invoicePagination.page.toString());
        params.set("limit", invoicePagination.limit.toString());

        // Add search term if exists
        if (searchInput && searchInput.trim()) {
          params.set("search", searchInput.trim());
          console.log(
            "Adding invoice search term to query:",
            searchInput.trim()
          );
        }

        // Add card-based filtering
        if (selectedInvoiceCard) {
          console.log("Adding invoice card filter:", selectedInvoiceCard);
          params.set("onClick", selectedInvoiceCard);
        }

        // Add filter parameters from InvoiceSelectionContext with proper empty string checking
        if (invoiceFilters && Object.keys(invoiceFilters).length > 0) {
          console.log("Adding invoice filters to query:", invoiceFilters);
          Object.entries(invoiceFilters).forEach(([key, value]) => {
            // IMPORTANT: Check for both truthy value AND non-empty string after trimming
            if (value && typeof value === "string" && value.trim() !== "") {
              params.set(key, value.trim());
            }
          });
        }

        const queryString = params.toString();
        console.log("DetailSection - Final invoice query string:", queryString);

        // Make API call
        response =
          role === "customer"
            ? await getInvoicesCustomer(queryString ? `?${queryString}` : "")
            : await getInvoicesCompany(queryString ? `?${queryString}` : "");

        const invoiceData = response?.data || {};
        console.log(
          "DetailSection API response invoice count:",
          invoiceData.invoice?.length || 0
        );

        // ALWAYS SET THE INVOICE DATA FOR STATS - THIS WAS MISSING
        setInvoiceData(invoiceData);

        // Update context with filtered results
        setFilteredInvoices(invoiceData.invoice || []);

        // Update pagination info if available
        // if (invoiceData.total !== undefined) {
        //   updatePaginationInfo(
        //     invoiceData.total,
        //     invoiceData.total > (invoiceData.page + 1) * invoiceData.limit
        //   );
        // }
        updateInvoicePaginationInfo(
          invoiceData.total || 0,
          (invoiceData.invoice || []).length === invoicePagination.limit
        );

        // Determine if we're in search/filter mode
        const hasActiveSearch = searchInput && searchInput.trim();
        const hasActiveFilters =
          selectedInvoiceCard ||
          (invoiceFilters &&
            Object.values(invoiceFilters).some(
              (val) => val && typeof val === "string" && val.trim() !== ""
            ));

        console.log("Invoice Search/Filter status:", {
          hasActiveSearch,
          hasActiveFilters,
        });

        if (hasActiveSearch || hasActiveFilters) {
          console.log(
            "Setting invoice search results with",
            (invoiceData.invoice || []).length,
            "invoices"
          );
          setSearchResults(invoiceData.invoice || []);
          setSearchType("invoices");
          setSearchMetadata({
            selectedCard: selectedInvoiceCard,
            filters: invoiceFilters,
            searchTerm: searchInput,
            totalInvoices: invoiceData.invoice?.length || 0,
            isUnified: true,
            role,
          });
          setHasPerformedSearch(true);
        } else {
          console.log(
            "No active invoice search/filters - clearing search state"
          );
          setSearchResults([]);
          setSearchType("");
          setSearchMetadata({});
          setHasPerformedSearch(false);
        }
      } catch (err) {
        console.error("Error fetching invoices:", err);
        // Clear everything on error
        setSearchResults([]);
        setSearchType("");
        setSearchMetadata({});
        setFilteredInvoices([]);
        setInvoiceData({});
        updateInvoicePaginationInfo(0, false);
      } finally {
        setIsLoading(false);
      }
    };

    // IMPORTANT: Always run when on Invoices tab to ensure fresh data on clear
    if (activeTab === "Invoices") {
      console.log("Running Invoice fetch with current state:", {
        selectedInvoiceCard,
        searchInput,
        invoiceFilters,
      });
      fetchInvoices();
    }
  }, [
    activeTab,
    role,
    invoicePagination.page,
    invoicePagination.limit,
    selectedInvoiceCard,
    searchInput, // searchInput is synced to invoiceSearchTerm
    invoiceFilters,
    invoiceRefreshKey,
    setFilteredInvoices,
    updateInvoicePaginationInfo,
    setIsLoading,
    //buildInvoiceQueryParams
  ]);

  const performSearch = async (searchTerm) => {
    try {
      if (!searchTerm.trim()) {
        setSearchResults([]);
        setsearchDetailSecData({});
        setSearchType("");
        setSearchMetadata({});
        setHasPerformedSearch(false);
        localStorage.setItem("hasSearched", "false");
        setSearchInput("");
        return;
      }

      let response;

      switch (activeTab) {
        case "Cases":
          if (!selectedCourtType) {
            showToast("Please select court type", "error");
            return;
          }

          const queryParams = buildQueryParams(searchTerm);
          console.log("Using filters in search:", filters);

          // Handle OtherCourt search
          if (selectedCourtType === "OtherCourt") {
            try {
              const otherCourtResponse =
                await getIsCheckedOtherCourtCasesAddedManually(
                  `?${queryParams}`
                );
              setSearchResults(otherCourtResponse?.data?.cases || []);
              setsearchDetailSecData(otherCourtResponse?.data || {});
              setSearchType("cases");
              setSearchMetadata(otherCourtResponse?.data || {});
            } catch (error) {
              console.error("Error searching OtherCourt cases:", error);
              setSearchResults([]);
            }
            break;
          }

          // For High Court and District Court
          if (!selectedCaseType) {
            showToast("Please select case type", "error");
            return;
          }

          if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedHighCourtCasesByCompany(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "HighCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedHighCourtCasesAddedManually(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "fetched"
          ) {
            response = await getIsCheckedDistrictCourtCasesByCompany(
              `?${queryParams}`
            );
          } else if (
            selectedCourtType === "DistrictCourt" &&
            selectedCaseType === "added"
          ) {
            response = await getIsCheckedDistrictCourtCasesAddedManually(
              `?${queryParams}`
            );
          }

          setSearchResults(response?.data?.cases || []);
          setsearchDetailSecData(response?.data || {});
          setSearchType("cases");
          setSearchMetadata(response?.data || {});
          break;

        // case "Tasks":
        //   const taskParams = new URLSearchParams();
        //   taskParams.set('search', searchTerm);

        //   // Add card-based filtering to search
        //   if (selectedCard) {
        //     switch (selectedCard) {
        //       case 'completed':
        //         taskParams.set('isCompleted', 'true');
        //         taskParams.set('onClick', 'completed');
        //         break;
        //       case 'pending':
        //         taskParams.set('isCompleted', 'false');
        //         taskParams.set('onClick', 'pending');
        //         break;
        //       case 'today':
        //         taskParams.set('onClick', 'today');
        //         break;
        //       case 'total':
        //         taskParams.set('onClick', 'total');
        //         break;
        //     }
        //   }

        //   const taskQueryString = taskParams.toString();

        //   if (taskTab === "assignedToMe") {
        //     response = await getTasksAssignedToUser(`?${taskQueryString}`);
        //   } else if (taskTab === "assignedByMe") {
        //     response = await getTasksAssignedByUser(`?${taskQueryString}`);
        //   }

        //   setSearchResults(response?.data?.tasks || response?.data || []);
        //   setTaskSecData(response?.data);
        //   setSearchType("tasks");
        //   setSearchMetadata({
        //     taskTab,
        //     selectedCard,
        //     totalTasks: response?.data?.tasks?.length || 0,
        //   });
        //   break;

        case "Notes":
          response = await searchNote(searchTerm);
          setSearchResults(response?.data?.notes || response?.data || []);
          setNotesData(response?.data);
          setSearchType("notes");
          setSearchMetadata({ totalNotes: response?.data?.notes?.length || 0 });
          break;

        case "Expenses":
          response = await searchExpenses(searchTerm);
          setSearchResults(response?.data?.expenses || response?.data || []);
          setExpenseData(response?.data);
          setSearchType("expenses");
          setSearchMetadata({
            totalExpenses: response?.data?.expenses?.length || 0,
          });
          break;

        case "Labels":
          response = await searchLabel(searchTerm);
          console.log("Labels search response:", response);

          let labelsData = [];
          if (response?.data?.labels) {
            labelsData = response.data.labels;
          } else if (response?.data && Array.isArray(response.data)) {
            labelsData = response.data;
          } else if (response?.labels) {
            labelsData = response.labels;
          }

          console.log("Processed labels data:", labelsData);

          setSearchResults(labelsData);
          setLabelData(response?.data);
          setSearchType("labels");
          setSearchMetadata({ totalLabels: labelsData.length || 0 });
          break;

        case "Add My Clients":
          response = await searchMyClient(searchTerm);
          setSearchResults(response?.data?.clients || response?.data || []);
          setMyClientsData(response?.data);
          setSearchType("clients");
          setSearchMetadata({
            totalClients: response?.data?.clients?.length || 0,
          });
          break;

        case "Invoices":
          if (role === "customer") {
            response = await InvoiceForClient(searchTerm);
          } else {
            response = await InvoiceForCompany(searchTerm);
          }
          setSearchResults(response?.data?.invoices || response?.data || []);
          setInvoiceData(response?.data);
          setSearchType("invoices");
          setSearchMetadata({
            role,
            totalInvoices: response?.data?.invoices?.length || 0,
          });
          break;

        case "Manage Users":
          response = await searchAddedUsers(searchTerm);
          const users = response?.data?.users || [];

          console.log(response?.data, "ffffffff");

          const filteredUsers = users.filter(
            (user) =>
              user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user?.phno?.includes(searchTerm)
          );

          setSearchResults(filteredUsers);
          setAddUserData(response?.data);
          setSearchType("addusers");
          setSearchMetadata({ totalUsers: filteredUsers.length });
          break;

        default:
          console.log(`No search implemented for ${activeTab}`);
          return;
      }

      setHasPerformedSearch(true);
      localStorage.setItem("hasSearched", "true");
    } catch (error) {
      console.error(`Error searching ${activeTab}:`, error);
      setSearchResults([]);
      setSearchType("");
      setSearchMetadata({});
    }
  };

  const hasActiveFilters = useMemo(() => {
    // For tasks, check search input and filters
    if (activeTab === "Tasks") {
      return (
        (searchInput && searchInput.trim()) ||
        selectedCard !== null ||
        (filters &&
          Object.values(filters).some((val) => val && val.trim() !== ""))
      );
    }

    // For invoices, check search input and filters
    if (activeTab === "Invoices") {
      return (
        (searchInput && searchInput.trim()) ||
        selectedInvoiceCard !== null ||
        (invoiceFilters &&
          Object.values(invoiceFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For clients, check search input and filters
    if (activeTab === "Add My Clients") {
      return (
        (searchInput && searchInput.trim()) ||
        (clientFilters &&
          Object.values(clientFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For labels, check search input and filters
    if (activeTab === "Labels") {
      return (
        (searchInput && searchInput.trim()) ||
        (labelFilters &&
          Object.values(labelFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For notes, check search input and filters
    if (activeTab === "Notes") {
      return (
        (searchInput && searchInput.trim()) ||
        (noteFilters &&
          Object.values(noteFilters).some((val) => val && val.trim() !== ""))
      );
    }

    // For expenses, check search input and filters
    if (activeTab === "Expenses") {
      return (
        (searchInput && searchInput.trim()) ||
        (expenseFilters &&
          Object.values(expenseFilters).some((val) => val && val.trim() !== ""))
      );
    }

    if (activeTab === "Manage Users") {
      const hasSearchInput = searchInput && searchInput.trim();
      const hasCardSelection = selectedUserCard !== null;
      const hasFilterValues =
        userFilters &&
        Object.values(userFilters).some((val) => val && val.trim() !== "");

      console.log("User filter check:", {
        hasSearchInput,
        hasCardSelection,
        hasFilterValues,
        searchInput,
        selectedUserCard,
        userFilters,
      });

      return hasSearchInput || hasCardSelection || hasFilterValues;
    }

    // For other tabs, keep existing logic
    return (
      (searchType === "cases" && searchResults.length > 0) ||
      selectedAssignedUser !== "" ||
      Object.values(filters || {}).some(
        (val) => val && val !== "all" && val !== ""
      )
    );
  }, [
    filters,
    selectedAssignedUser,
    searchType,
    searchResults,
    selectedCard,
    selectedInvoiceCard,
    invoiceFilters,
    labelFilters,
    noteFilters,
    expenseFilters,
    userFilters, // Add this
    selectedUserCard, // Add this
    searchInput,
    activeTab,
  ]);

  useEffect(() => {
    if (searchType === "" && searchResults.length === 0) {
      console.log("Search completely cleared - ensuring display cases reset");
    }
  }, [searchType, searchResults]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const trimmedInput = searchInput.trim();

      // Handle empty search input properly
      if (trimmedInput === "") {
        console.log("Search input is empty, clearing all search state");
        setSearchResults([]);
        setsearchDetailSecData({});
        setSearchType("");
        setSearchMetadata({});
        setHasPerformedSearch(false);
        localStorage.setItem("hasSearched", "false");

        // For Tasks tab, also sync with context
        if (activeTab === "Tasks") {
          setSearchTerm(""); // Clear context search term
        }

        // For Labels tab, also sync with context
        if (activeTab === "Labels") {
          setLabelSearchTerm(""); // Clear context search term
        }

        // For Notes tab, also sync with context
        if (activeTab === "Notes") {
          setNoteSearchTerm(""); // Clear context search term
        }

        // For Expenses tab, also sync with context
        if (activeTab === "Expenses") {
          setExpenseSearchTerm(""); // Clear context search term
        }

        // ADD THIS NEW BLOCK FOR USERS
        if (activeTab === "Manage Users") {
          setUserSearchTerm(""); // Clear context search term
        }

        return;
      }

      // Skip debounced search for Tasks, Labels, Notes, Expenses, and Users - they're handled elsewhere
      if (activeTab === "Tasks") {
        console.log("Setting search term for Tasks in context:", trimmedInput);
        setSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }
      // ADD THIS NEW BLOCK FOR CLIENTS
      if (activeTab === "Add My Clients") {
        console.log(
          "Setting search term for Clients in context:",
          trimmedInput
        );
        setClientSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }

      if (activeTab === "Labels") {
        console.log("Setting search term for Labels in context:", trimmedInput);
        setLabelSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }

      if (activeTab === "Notes") {
        console.log("Setting search term for Notes in context:", trimmedInput);
        setNoteSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }

      if (activeTab === "Expenses") {
        console.log(
          "Setting search term for Expenses in context:",
          trimmedInput
        );
        setExpenseSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }

      // ADD THIS NEW BLOCK FOR USERS
      if (activeTab === "Manage Users") {
        console.log("Setting search term for Users in context:", trimmedInput);
        setUserSearchTerm(trimmedInput); // This will trigger the unified useEffect
        return;
      }

      // Handle other tabs search
      if (activeTab === "Cases" && !username) return;

      console.log("Performing search with term:", trimmedInput);
      showLoading();
      performSearch(trimmedInput).finally(() => hideLoading());
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [
    searchInput,
    username,
    activeTab,
    taskTab,
    role,
    selectedCourtType,
    selectedCaseType,
    companyID,
    setUserSearchTerm, // Add this dependency
  ]);

  const isSearchActive = hasPerformedSearch && searchType !== "";

  const clearSearchState = useCallback(() => {
    console.log("Completely clearing search state");
    setSearchResults([]);
    setsearchDetailSecData({});
    setSearchType("");
    setSearchMetadata({});
    setHasPerformedSearch(false);
    localStorage.setItem("hasSearched", "false");

    const searchInput = document.querySelector(".detailsection-search-input");
    if (searchInput) {
      searchInput.value = "";
    }
  }, [
    setSearchResults,
    setsearchDetailSecData,
    setSearchType,
    setSearchMetadata,
    setHasPerformedSearch,
  ]);

  // Add this function in DetailSection component
  const clearSearchInput = useCallback(() => {
    setSearchInput("");
  }, []);

  // Make this function available globally so MyClients can access it
  useEffect(() => {
    window.clearDetailSectionSearch = clearSearchInput;
    return () => {
      delete window.clearDetailSectionSearch;
    };
  }, [clearSearchInput]);

  console.log(searchdetailSecData, "searchdetailSecDatasearchdetailSecData");

  const statsToDisplayCases = [
    {
      title: "Total Cases",
      value: isSearchActive
        ? searchdetailSecData.totalCases || 0
        : detailSecData?.totalCases || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleCaseCardClick(""), // Changed function name
      isActive: false, // Changed from selectedCard
    },
    {
      title: "Filtered Cases",
      value: isSearchActive
        ? searchResults.length || 0
        : hasActiveFilters
        ? detailSecData?.cases?.length || 0
        : detailSecData?.totalCases || 0,
    },
    {
      title: "Pending Cases",
      value: isSearchActive
        ? searchdetailSecData?.pendingCaseCount || 0
        : detailSecData?.pendingCaseCount || 0,
      cardType: "pending",
      isClickable: true,
      onClick: () => handleCaseCardClick("pending"), // Changed function name
      isActive: selectedCaseCard === "pending", // Changed from selectedCard
    },
    {
      title: "Closed Cases",
      value: isSearchActive
        ? searchdetailSecData?.disposedCaseCount || 0
        : detailSecData?.disposedCaseCount || 0,
      cardType: "closed",
      isClickable: true,
      onClick: () => handleCaseCardClick("closed"), // Changed function name
      isActive: selectedCaseCard === "closed", // Changed from selectedCard
    },
    {
      title: "Objection Raised",
      value: isSearchActive
        ? searchdetailSecData?.totalObjections || 0
        : detailSecData?.totalObjections || 0,
      isClickable: true,
      cardType: "objection",
      onClick: () => handleCaseCardClick("objection"),
      isActive: selectedCaseCard === "objection",
    },
  ];

  const statsToDisplayTasks = [
    {
      title: "Total Tasks",
      value: TaskSecData?.totalTasks || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleCardClick(""),
      isActive: false,
    },
    {
      title: "Today's Tasks",
      value: TaskSecData?.dueTodayCount || 0,
      cardType: "today",
      isClickable: true,
      onClick: () => handleCardClick("today"),
      isActive: selectedCard === "today",
    },
    {
      title: "Pending Tasks",
      value: TaskSecData?.pendingTasks || 0,
      cardType: "pending",
      isClickable: true,
      onClick: () => handleCardClick("pending"),
      isActive: selectedCard === "pending",
    },
    {
      title: "Completed Tasks",
      value: TaskSecData?.completedTasks || 0,
      cardType: "completed",
      isClickable: true,
      onClick: () => handleCardClick("completed"),
      isActive: selectedCard === "completed",
    },
  ];
  const statsToDisplayMyClients = [
    {
      title: "Total Clients",
      value: MyClientsData?.clientCount,
    },
  ];
  const statsToDisplayLabels = [
    {
      title: "Total Labels",
      value: LabelData?.total,
    },
  ];
  const statsToDisplayBranch = [
    {
      title: "Total Branch",
      value: BranchData?.totalBranches,
    },
  ];
  const statsToDisplayAddedUsers = [
    {
      title: "Total Added Users",
      value: AddUserData?.totalUsers || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => handleUserCardClick(""),
      //isActive: selectedUserCard === "total",
      isActive: false,
    },
    {
      title: "Total Active Users",
      value: AddUserData?.activeUsers || 0,
      cardType: "active",
      isClickable: true,
      onClick: () => handleUserCardClick("active"),
      isActive: selectedUserCard === "active",
    },
    {
      title: "Total Inactive Users",
      value: AddUserData?.inactiveUsers || 0,
      cardType: "inactive",
      isClickable: true,
      onClick: () => handleUserCardClick("inactive"),
      isActive: selectedUserCard === "inactive",
    },
  ];
  const statsToDisplayNotes = [
    {
      title: "Total Notes",
      value: NotesData.total,
    },
  ];
  const statsToDisplayExpenses = [
    {
      title: "Total Expenses",
      value: ExpenseData?.expenseCount,
    },
    {
      title: "Total Amount",
      value: ExpenseData?.totalAmount,
    },
  ];
  // Helper to format numbers as 13.9k, 1.2M, etc.
  function formatNumberAbbr(num) {
    // Handle undefined, null, or invalid numbers
    if (num === undefined || num === null || num === "") return "0";
    if (typeof num !== "number") num = Number(num);
    if (isNaN(num)) return "0";
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
    return num.toString();
  }

  console.log(InvoiceData, "InvoiceData");
  const statsToDisplayInvoices = [
    // {
    //   title: "Total Invoices",
    //   value: InvoiceData?.total || 0,
    //   cardType: "total",
    //   isClickable: true,
    //   onClick: () => handleInvoiceCardClick("total"),
    //   isActive: selectedInvoiceCard === "total",
    // },
    {
      title: "Total Invoices",
      value: InvoiceData?.total || 0,
      cardType: "total",
      isClickable: true,
      onClick: () => {
        // Clear all filters when clicking Total Invoices
        clearInvoiceFilters();
        // Also clear local filters in the Invoices component
        if (window.clearInvoiceFilters) {
          window.clearInvoiceFilters();
        }
        // Clear the search input in DetailSection
        if (window.clearDetailSectionSearch) {
          window.clearDetailSectionSearch();
        }
        // Reset the card selection
        handleInvoiceCardClick(null);
      },
      isActive: selectedInvoiceCard === "total",
    },
    {
      title: "Paid Invoices",
      value: (
        <>
          {InvoiceData?.totalPaid || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPaid || 0)}
        </>
      ),
      cardType: "paid",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("paid"),
      isActive: selectedInvoiceCard === "paid",
    },
    {
      title: "Part-Pay Invoices",
      value: (
        <>
          {InvoiceData?.totalPartPayment || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPartPayment || 0)}
        </>
      ),
      cardType: "part-payment",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("part-payment"),
      isActive: selectedInvoiceCard === "part-payment",
    },
    {
      title: "Pending Invoices",
      value: (
        <>
          {InvoiceData?.totalPending || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountPending || 0)}
        </>
      ),
      cardType: "pending",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("pending"),
      isActive: selectedInvoiceCard === "pending",
    },
    {
      title: "Cancelled Invoices",
      value: (
        <>
          {InvoiceData?.totalCancelled || 0} -{" "}
          <span className="currency-symbol">{currencySign}</span>
          {formatNumberAbbr(InvoiceData?.totalAmountCancelled || 0)}
        </>
      ),
      cardType: "cancelled",
      isClickable: true,
      onClick: () => handleInvoiceCardClick("cancelled"),
      isActive: selectedInvoiceCard === "cancelled",
    },
  ];

  const handleNewButtonClick = async () => {
    if (activeTab === "Cases") {
      // Check if we're still loading case limit data
      if (isCaseLimitLoading) {
        showToast("Loading case data, please wait...", "info");
        return;
      }

      // Use preloaded data for instant check
      if (!caseLimitData) {
        // Fallback: fetch if not available
        try {
          showToast("Checking case limit...", "info");
          await refreshCaseLimitData();
          // Data will be available after refresh, check on next render
          return;
        } catch (error) {
          console.error("Error fetching case limit:", error);
          showToast("Error checking case limit. Please try again.", "error");
          return;
        }
      }

      // Use preloaded data for instant check
      const totalCases = caseLimitData?.cases?.totalCases || 0;
      const caseLimit = caseLimitData?.limit?.caseLimit || 0;

      console.log("Checking case limit:", { totalCases, caseLimit });

      if (totalCases >= caseLimit) {
        showToast(
          "You have reached the case limit for your plan. Please contact your administrator",
          "warning"
        );
        return;
      }

      navigate("/home/cases/newcase");
      return;
    }

    if (activeTab === "Manage Users") {
      if (isUserLimitLoading) {
        showToast("Loading user data, please wait...", "info");
        return;
      }
      if (!userLimitData) {
        try {
          showToast("Checking user limit...", "info");
          const response = await getUserLimit();
          setUserLimitData(response.data);

          const userLimit = response.data.limit.usersLimit;
          const activeUsers = AddUserData?.activeUsers || 0;

          if (activeUsers >= userLimit) {
            setIsUserLimitModalOpen(true);
            return;
          }

          navigate("/home/addusers/add-user");
        } catch (error) {
          console.error("Error fetching user limit:", error);
          showToast("Error checking user limit. Please try again.", "error");
        }

        return;
      }

      // Use preloaded data for instant check
      const userLimit = userLimitData.limit.usersLimit;
      const activeUsers = AddUserData?.activeUsers || 0;

      console.log("Checking limit:", { userLimit, activeUsers });

      if (activeUsers >= userLimit) {
        setIsUserLimitModalOpen(true);
        return;
      }

      navigate("/home/addusers/add-user");
    } else if (activeTab === "Tasks") {
      navigate("/home/tasks/newtask");
    } else if (activeTab === "Labels") {
      navigate("/home/labels/newlabel");
    } else if (activeTab === "Expenses") {
      navigate("/home/expenses/newexpense");
    } else if (activeTab === "Notes") {
      navigate("/home/notes/newnote");
    } else if (activeTab === "Branch") {
      setIsNewBranchModalOpen(true);
    } else if (activeTab === "Add My Clients") {
      navigate("/home/my-clients/add-client");
    } else if (activeTab === "Invoices") {
      navigate("/home/invoices/add");
    } else {
      navigate("/case");
    }
  };
  const getSearchPlaceholder = () => {
    switch (activeTab) {
      case "Cases":
        return "Search cases...";
      case "Tasks":
        return "Search tasks...";
      case "Expenses":
        return "Search expenses...";
      case "Labels":
        return "Search labels...";
      case "Add My Clients":
        return "Search clients...";
      case "Invoices":
        return "Search invoices...";
      case "Notes":
        return "Search notes...";
      case "Branch":
        return "Search branches...";
      case "Manage Users":
        return "Search users...";
      default:
        return "Search...";
    }
  };

  const caseFileInputRef = useRef(null);
  const userFileInputRef = useRef(null);

  // Add this function for sample sheet download
  const handleCaseSampleSheetDownload = async () => {
    try {
      const response = await fetch(caseSampleSheet);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_cases_template.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("Sample sheet downloaded successfully!", "success");
    } catch (error) {
      console.error("Error downloading sample sheet:", error);
      showToast("Failed to download sample sheet.", "error");
    }
  };

  // User sample sheet download
  const handleUserSampleSheetDownload = async () => {
    try {
      const response = await fetch(userSampleSheet);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_users_template.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      showToast("Sample sheet downloaded successfully!", "success");
    } catch (error) {
      console.error("Error downloading sample sheet:", error);
      showToast("Failed to download sample sheet.", "error");
    }
  };

  // Drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = e.dataTransfer.files;
    if (files && files[0]) {
      // Manually trigger the file input change with the dropped file
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(files[0]);
      caseFileInputRef.current.files = dataTransfer.files;
      
      // Trigger the change event
      const event = new Event('change', { bubbles: true });
      caseFileInputRef.current.dispatchEvent(event);
    }
  };

  // Drag and drop handlers for users
  const handleUserDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleUserDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = e.dataTransfer.files;
    if (files && files[0]) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(files[0]);
      userFileInputRef.current.files = dataTransfer.files;
      
      const event = new Event('change', { bubbles: true });
      userFileInputRef.current.dispatchEvent(event);
    }
  };

  // User file change handler
  const handleUserFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      showToast("Please upload a valid Excel file (.xlsx or .xls)", "error");
      return;
    }

    try {
      showLoading();
      const formData = new FormData();
      formData.append("file", file);

      await uploadUsersSpreadsheetUsers(formData);
      showToast("Users spreadsheet uploaded successfully!", "success");

      // Close the import modal on successful upload
      setIsImportUsersModalOpen(false);

      // Refresh user data
      const res = await getHierarchy();
      const userData = res.data.users || [];
      setAddUserData(res.data);
      setFilteredUsers(userData);
    } catch (err) {
      console.error("Error uploading users spreadsheet:", err);
      showToast(
        err?.response?.data?.message || "Failed to upload spreadsheet.",
        "error"
      );
    } finally {
      hideLoading();
      if (userFileInputRef.current) {
        userFileInputRef.current.value = "";
      }
    }
  };

  const handleCaseFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.name.match(/\.(xlsx|xls)$/)) {
      showToast("Please upload a valid Excel file (.xlsx or .xls)", "error");
      return;
    }

    try {
      showLoading();

      // ✅ STEP 1: Read the Excel file to count rows (excluding header)
      const XLSX = await import("xlsx");
      const fileBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(fileBuffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const jsonDataWithHeaders = XLSX.utils.sheet_to_json(worksheet); 


      // Count rows excluding the header row
      const totalRowsInFile = jsonDataWithHeaders.length;

      // 🔍 CONSOLE 1: Raw Excel data
      console.log("===== EXCEL FILE ANALYSIS =====");
      console.log("Total rows in Excel (including header):", jsonData.length);
      console.log("Data rows (excluding header):", totalRowsInFile);
      console.log("First 3 rows of Excel:", jsonData.slice(0, 3));

      // ✅ STEP 2: Check case limit
      const currentTotalCases = caseLimitData?.cases?.totalCases || 0;
      const caseLimit = caseLimitData?.limit?.caseLimit || 0;

      // 🔍 CONSOLE 2: Case limit data
      console.log("===== CASE LIMIT DATA =====");
      console.log("Full caseLimitData object:", caseLimitData);
      console.log("caseLimitData.cases:", caseLimitData?.cases);
      console.log("caseLimitData.limit:", caseLimitData?.limit);
      console.log("Current total cases:", currentTotalCases);
      console.log("Case limit:", caseLimit);
      console.log("Available slots:", caseLimit - currentTotalCases);

      // 🔍 CONSOLE 3: Calculation check
      console.log("===== LIMIT CHECK CALCULATION =====");
      console.log("Will add:", totalRowsInFile, "rows");
      console.log("New total would be:", currentTotalCases + totalRowsInFile);
      console.log("Limit is:", caseLimit);
      console.log(
        "Will exceed limit?",
        currentTotalCases + totalRowsInFile > caseLimit
      );
      console.log(
        "Comparison:",
        `${currentTotalCases} + ${totalRowsInFile} = ${
          currentTotalCases + totalRowsInFile
        } > ${caseLimit} = ${currentTotalCases + totalRowsInFile > caseLimit}`
      );

      // ✅ STEP 3: Prevent upload if limit will be exceeded
      if (currentTotalCases + totalRowsInFile > caseLimit) {
        console.log("🚫 UPLOAD BLOCKED - Would exceed limit");
        hideLoading();
        setIsCaseLimitModalOpen(true);
        if (caseFileInputRef.current) {
          caseFileInputRef.current.value = "";
        }
        return;
      }

      console.log("✅ UPLOAD ALLOWED - Within limit");

      // ✅ STEP 4: Proceed with upload if within limit
      const formData = new FormData();
      formData.append("file", file);

      console.log("📤 Uploading case file:", file.name);
      console.log("File size:", file.size, "bytes");

      const response = await uploadCasesSpreadsheet(formData);

      console.log("Full upload response:", response);

      // Extract response data - handle nested structure
      const responseData = response?.data?.data || response?.data;
      const errors = responseData?.errors || [];
      const processedCases = responseData?.processedCases || 0;
      const newCases = responseData?.newCases || 0;
      const existingCases = responseData?.existingCases || 0;

      // 🔍 CONSOLE 4: Upload results
      console.log("===== UPLOAD RESULTS =====");
      console.log("Processed cases:", processedCases);
      console.log("New cases added:", newCases);
      console.log("Existing cases skipped:", existingCases);
      console.log("Errors:", errors);

      // Check if there are errors
      if (errors.length > 0) {
        // Check if it's a missing fields error (single general error)
        if (errors[0].includes("Missing required fields")) {
          showToast(
            "Missing required fields (Court Type, Parties, Court Name, or Cnr No). Please check the sample sheet and try again.",
            "error"
          );
        } else {
          // For duplicate cases, show all errors line by line
          const errorMessage = errors.join("\n");
          showToast(errorMessage, "error", 1000); 
        }
        console.error("Upload errors:", errors);
      } else {
        showToast(
          `Successfully uploaded! ${processedCases} case(s) processed, ${newCases} new case(s) added${
            existingCases > 0
              ? `, ${existingCases} existing case(s) skipped`
              : ""
          }.`,
          "success"
        );

        // Close the import modal on successful upload
        setIsImportCasesModalOpen(false);

        // Refresh case limit data and cases list
        console.log("===== REFRESHING DATA AFTER UPLOAD =====");
        await refreshCaseLimitData();
        console.log("Case limit data refreshed successfully");
        
        // Trigger case list refresh to show newly imported cases
        console.log("Triggering case list refresh...");
        triggerCaseRefresh();
      }
    } catch (err) {
      console.error("❌ Error uploading cases spreadsheet:", err);
      console.error("Error details:", {
        message: err.message,
        code: err.code,
        status: err.response?.status,
        data: err.response?.data,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          baseURL: err.config?.baseURL,
        },
      });

      // Handle different types of errors with specific messages
      if (err.code === "ERR_NETWORK" || err.message === "Network Error") {
        showToast(
          "Cannot connect to server. Please verify:\n1. Backend server is running\n2. API endpoint 'case/add-cases-spreadsheet' exists\n3. Network connection is stable",
          "error"
        );
      } else if (err.response?.status === 404) {
        showToast(
          "API endpoint not found. Please contact the administrator to verify the backend route '/case/add-cases-spreadsheet' exists.",
          "error"
        );
      } else if (err.response?.status === 413) {
        showToast(
          "File is too large. Please upload a smaller file or increase server file size limit.",
          "error"
        );
      } else if (err.response?.status === 400) {
        showToast(
          err.response?.data?.message ||
            "Invalid file format. Please check the sample sheet and ensure all required fields are present.",
          "error"
        );
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        showToast("Authentication error. Please log in again.", "error");
      } else if (err.response?.status === 500) {
        showToast(
          "Server error occurred while processing your file. Please try again or contact support.",
          "error"
        );
      } else {
        showToast(
          err?.response?.data?.message ||
            "Failed to upload spreadsheet. Please try again.",
          "error"
        );
      }
    } finally {
      hideLoading();
      if (caseFileInputRef.current) {
        caseFileInputRef.current.value = "";
      }
    }
  };
  return (
    <>
      <div className="detailsection-dashboard-wrapper">
        <div className="detailsection-dashboard-header">
          <div className="detailsection-right-buttons ">
            <button className="new-case-btn" onClick={handleNewButtonClick}>
              + New{" "}
              {activeTab === "Cases"
                ? "Case"
                : activeTab === "Tasks"
                ? "Task"
                : activeTab === "Manage Users"
                ? "User"
                : activeTab === "Add My Clients"
                ? "Client"
                : activeTab}
            </button>
            {activeTab !== "Branch" && (
              <input
                type="text"
                placeholder={getSearchPlaceholder()}
                className="detailsection-search-input"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            )}
          </div>

          {(isCases || isTasks || isInvoices || activeTab === "Manage Users") && (
            <div className="detailsection-right-buttons">
              {isCases && (
                <>
                  <button
                    className="detailsection-export-btn"
                    onClick={() => setIsImportCasesModalOpen(true)}
                  >
                    Import Cases
                  </button>
                </>
              )}
              {activeTab === "Manage Users" && (
                <>
                  <button
                    className="detailsection-export-btn"
                    onClick={() => setIsImportUsersModalOpen(true)}
                  >
                    Import Users
                  </button>
                </>
              )}
              {/* {isTasks && (
                <>
                  <button className="detailsection-export-btn">
                    Sample Sheet
                  </button>
                  <button className="detailsection-export-btn">
                    Import cases
                  </button>
                </>
              )} */}
              {(isCases || isTasks || isInvoices) && (
                <button
                  className="detailsection-export-btn"
                  onClick={async () => {
                    if (activeTab === "Cases") {
                      setIsPdfExportModalOpen(true);
                    } else if (activeTab === "Tasks") {
                      await exportTasksToExcel(
                        searchResults.length > 0
                          ? searchResults
                          : TaskSecData.tasks,
                        showToast
                      );
                    } else if (activeTab === "Invoices") {
                      setIsInvoiceExportModalOpen(true);
                    }
                  }}
                >
                  <img
                    src={impexp}
                    alt="impexp"
                    className="detailsection-impexpicon"
                  />
                  {activeTab === "Cases" && "Export Cases"}
                  {activeTab === "Tasks" && "Export Tasks"}
                  {activeTab === "Invoices" && "Export Invoices"}
                </button>
              )}
            </div>
          )}
        </div>
        <div className="detailsection-dashboard-cards">
          {activeTab === "Cases" &&
            statsToDisplayCases.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Tasks" &&
            statsToDisplayTasks.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Manage Users" &&
            statsToDisplayAddedUsers.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
          {activeTab === "Add My Clients" &&
            statsToDisplayMyClients.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Labels" &&
            statsToDisplayLabels.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Branch" &&
            statsToDisplayBranch.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Notes" &&
            statsToDisplayNotes.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Expenses" &&
            statsToDisplayExpenses.map((item, index) => (
              <DetailCard key={index} title={item.title} value={item.value} />
            ))}
          {activeTab === "Invoices" &&
            statsToDisplayInvoices.map((item, index) => (
              <DetailCard
                key={index}
                title={item.title}
                value={item.value}
                onClick={item.onClick}
                isClickable={item.isClickable}
                isActive={item.isActive}
                cardType={item.cardType}
              />
            ))}
        </div>

        {isPdfExportModalOpen && (
          <CommonModal onClose={() => setIsPdfExportModalOpen(false)}>
            <div className="pdf-export-modal">
              <h2 className="export-modal-title">Export Cases to PDF</h2>

              {/* Orientation Selection */}
              <div className="export-modal-options">
                <label className="export-modal-option">
                  <input
                    type="radio"
                    value="portrait"
                    checked={pdfOrientation === "portrait"}
                    onChange={(e) => setPdfOrientation(e.target.value)}
                  />
                  <span>Portrait Orientation</span>
                </label>
                <p className="export-modal-desc">
                  Default detailed view - Best for comprehensive case
                  information
                </p>

                <label className="export-modal-option">
                  <input
                    type="radio"
                    value="landscape"
                    checked={pdfOrientation === "landscape"}
                    onChange={(e) => setPdfOrientation(e.target.value)}
                  />
                  <span>Landscape Orientation</span>
                </label>
                <p className="export-modal-desc">
                  Wide view with more columns - Best for tabular data display
                </p>
              </div>

              <div className="export-modal-actions">
                <button
                  className="btn-cancel"
                  onClick={() => setIsPdfExportModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn-export"
                  onClick={() => handleExportPDF(pdfOrientation)}
                >
                  Export to PDF
                </button>
              </div>
            </div>
          </CommonModal>
        )}
        {isInvoiceExportModalOpen && (
          <CommonModal onClose={() => setIsInvoiceExportModalOpen(false)}>
            <div className="invoice-export-modal">
              <h3>Export Invoices</h3>
              <p className="export-subtext">
                Choose filters and export invoices in Excel format
              </p>

              <div className="filter-sections">
                {/* Status Filter */}
                <div className="filter-section">
                  <h4 className="filter-title">Payment Status</h4>
                  <div className="filter-options">
                    {["all", "pending", "paid", "part-payment"].map(
                      (status) => (
                        <label key={status} className="filter-option">
                          <input
                            type="radio"
                            name="status"
                            value={status}
                            checked={selectedStatus === status}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                          />
                          <span className="filter-label">
                            {status === "all"
                              ? "All Statuses"
                              : status === "part-payment"
                              ? "Part Payment"
                              : status.charAt(0).toUpperCase() +
                                status.slice(1)}
                          </span>
                        </label>
                      )
                    )}
                  </div>
                </div>
                <div className="filter-section">
                  <h4 className="filter-title">Date Range</h4>
                  <div className="filter-options">
                    {[
                      {
                        value: "current-month",
                        label: "Current Month (August 2025)",
                      },
                      { value: "last-month", label: "Last Month (July 2025)" },
                      { value: "june-2025", label: "June 2025" },
                      { value: "may-2025", label: "May 2025" },
                      { value: "april-2025", label: "April 2025" },
                      { value: "march-2025", label: "March 2025" },
                      {
                        value: "previous-fy",
                        label: "Previous Financial Year",
                      },
                      { value: "select-range", label: "Select Date Range" },
                    ].map((dateRange) => (
                      <label key={dateRange.value} className="filter-option">
                        <input
                          type="radio"
                          name="dateRange"
                          value={dateRange.value}
                          checked={selectedDateRange === dateRange.value}
                          onChange={(e) => {
                            console.log("Radio changed to:", e.target.value);
                            setSelectedDateRange(e.target.value);
                          }}
                        />
                        <span className="filter-label">{dateRange.label}</span>
                      </label>
                    ))}
                  </div>

                  {/* Show date inputs when "Select Date Range" is selected */}
                  {selectedDateRange === "select-range" && (
                    <div className="date-range-inputs">
                      <div className="date-input-group">
                        <label>Start Date:</label>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="date-input-group">
                        <label>End Date:</label>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="export-actions">
                <button
                  className="export-btn cancel-btn"
                  onClick={() => {
                    setSelectedStatus("all");
                    setSelectedDateRange("current-month");
                    setStartDate("");
                    setEndDate("");
                    setIsInvoiceExportModalOpen(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="export-btn export-btn-primary"
                  onClick={handleInvoiceExport}
                >
                  Export Invoices
                </button>
              </div>
            </div>
          </CommonModal>
        )}
        {isNewBranchModalOpen && (
          <CommonModal onClose={() => setIsNewBranchModalOpen(false)}>
            <BranchForm
              onClose={() => setIsNewBranchModalOpen(false)}
              companyID={companyID}
              showToast={showToast}
              onSuccess={() => {
                setIsNewBranchModalOpen(false);
                window.location.reload();
              }}
            />
          </CommonModal>
        )}

        {isUserLimitModalOpen && (
          <CommonModal onClose={() => setIsUserLimitModalOpen(false)}>
            <div className="user-limit-modal">
              <div className="limit-icon">⚠️</div>
              <h3>User Limit Reached</h3>
              <p className="limit-message">
                You have reached your maximum user limit. To add more users, you
                can:
              </p>
              <div className="limit-options">
                <div
                  className="limit-option clickable"
                  onClick={() => setIsUserLimitModalOpen(false)}
                >
                  <span className="option-icon">🗑️</span>
                  <span>Delete or deactivate existing users</span>
                </div>
                <div
                  className="limit-option clickable"
                  onClick={() => {
                    setIsUserLimitModalOpen(false);
                    window.open(
                      "http://lawsuit-pro.com/pricing.html",
                      "_blank"
                    );
                  }}
                >
                  <span className="option-icon">⬆️</span>
                  <span>Upgrade your plan for more users</span>
                </div>
              </div>
              <div className="limit-actions">
                <button
                  className="limit-btn secondary"
                  onClick={() => setIsUserLimitModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="limit-btn primary"
                  onClick={() => {
                    setIsUserLimitModalOpen(false);
                    window.open(
                      "http://lawsuit-pro.com/pricing.html",
                      "_blank"
                    );
                  }}
                >
                  Upgrade Plan
                </button>
              </div>
            </div>
          </CommonModal>
        )}

        {isImportCasesModalOpen && (
          <CommonModal onClose={() => setIsImportCasesModalOpen(false)}>
            <div className="import-clients-modal">
              <h2 className="import-modal-title">Import Cases</h2>
              <div className="import-modal-content">
                <div 
                  className="upload-section"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onClick={() => caseFileInputRef.current.click()}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="upload-icon-container">
                    <svg
                      className="upload-icon"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <p className="upload-text">
                    Drag-and-drop documents here
                    <br />
                    (or click to browse...)
                  </p>
                  <button
                    className="browse-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      caseFileInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </button>
                </div>
                <div className="modal-actions">
                  <button
                    className="action-btn download-btn"
                    onClick={handleCaseSampleSheetDownload}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Download sample file
                  </button>
                  <button
                    className="action-btn close-btn"
                    onClick={() => setIsImportCasesModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </CommonModal>
        )}

        {isImportUsersModalOpen && (
          <CommonModal onClose={() => setIsImportUsersModalOpen(false)}>
            <div className="import-clients-modal">
              <h2 className="import-modal-title">Import Users</h2>
              <div className="import-modal-content">
                <div 
                  className="upload-section"
                  onDragOver={handleUserDragOver}
                  onDrop={handleUserDrop}
                  onClick={() => userFileInputRef.current.click()}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="upload-icon-container">
                    <svg
                      className="upload-icon"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                  </div>
                  <p className="upload-text">
                    Drag-and-drop documents here
                    <br />
                    (or click to browse...)
                  </p>
                  <button
                    className="browse-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      userFileInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </button>
                </div>
                <div className="modal-actions">
                  <button
                    className="action-btn download-btn"
                    onClick={handleUserSampleSheetDownload}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Download sample file
                  </button>
                  <button
                    className="action-btn close-btn"
                    onClick={() => setIsImportUsersModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </CommonModal>
        )}
      </div>
      {/* Hidden file input for case import */}
      <input
        type="file"
        ref={caseFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleCaseFileChange}
      />

      {/* Hidden file input for user import */}
      <input
        type="file"
        ref={userFileInputRef}
        style={{ display: "none" }}
        accept=".xlsx,.xls"
        onChange={handleUserFileChange}
      />

      {isCaseLimitModalOpen && (
  <CommonModal onClose={() => setIsCaseLimitModalOpen(false)}>
    <div className="user-limit-modal compact-limit-modal">
      <div className="limit-icon">⚠️</div>
      <h3>Case Limit Exceeded</h3>
      <p className="limit-message">
        This upload would exceed your case limit.
      </p>
      <div className="limit-stats-compact">
        <div className="stat-item">
          <span className="stat-label">Current:</span>
          <span className="stat-value">{caseLimitData?.cases?.totalCases || 0}</span>
        </div>
        <div className="stat-divider">/</div>
        <div className="stat-item">
          <span className="stat-label">Limit:</span>
          <span className="stat-value">{caseLimitData?.limit?.caseLimit || 0}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Available:</span>
          <span className="stat-value">
            {(caseLimitData?.limit?.caseLimit || 0) - (caseLimitData?.cases?.totalCases || 0)}
          </span>
        </div>
      </div>
      <p className="limit-message-small">
        Reduce cases in spreadsheet or upgrade your plan.
      </p>
      <div className="limit-actions-compact">
        <button
          className="limit-btn secondary"
          onClick={() => setIsCaseLimitModalOpen(false)}
        >
          Cancel
        </button>
        <button
          className="limit-btn primary"
          onClick={() => {
            setIsCaseLimitModalOpen(false);
            window.open("http://lawsuit-pro.com/pricing.html", "_blank");
          }}
        >
          Upgrade
        </button>
      </div>
    </div>
  </CommonModal>
)}
    </>
  );
};
